import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useImpersonationStore } from "@/store/impersonationStore";
import { MaterialIcon } from "./MaterialIcon";

export function ImpersonationBanner() {
  const { impersonatedUid, impersonatedName, impersonatedEmail, stopImpersonation } =
    useImpersonationStore();
  const navigate = useNavigate();

  if (!impersonatedUid) return null;

  return (
    <div
      style={{
        background: "#ff4d4f",
        color: "white",
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        fontSize: 14,
        fontWeight: 500,
        position: "relative",
        zIndex: 100,
        flexShrink: 0,
      }}
    >
      <MaterialIcon name="supervisor_account" size={18} />
      <span>
        Impersonating <strong>{impersonatedName || "Unknown"}</strong>
        {impersonatedEmail && ` (${impersonatedEmail})`}
      </span>
      <Button
        size="small"
        type="default"
        style={{
          background: "rgba(255,255,255,0.9)",
          borderColor: "transparent",
          fontWeight: 600,
        }}
        onClick={() => {
          stopImpersonation();
          navigate("/");
        }}
      >
        Exit
      </Button>
    </div>
  );
}
